import Splide from '@splidejs/splide';

let woocommerceProductGalleryMain = document.getElementById( 'woocommerce-product-gallery-main' );
let woocommerceProductGalleryThumbs = document.getElementById( 'woocommerce-product-gallery-thumbs' );
let giftWrappers = [];


if( woocommerceProductGalleryMain && woocommerceProductGalleryThumbs ) {
  var productGallery = new Splide( '#woocommerce-product-gallery-main', {
    pagination: false,
    arrows:false,
  } );

  var thumbnails = document.getElementsByClassName( 'woocommerce-product-gallery__thumbnail' );
  var current;

  for ( var i = 0; i < thumbnails.length; i++ ) {
    initThumbnail( thumbnails[ i ], i );
  }

  function initThumbnail( thumbnail, index ) {
    thumbnail.addEventListener( 'click', function () {
      productGallery.go( index );
    } );
  }

  productGallery.on( 'mounted move', function () {
    var thumbnail = thumbnails[ productGallery.index ];

    if ( thumbnail ) {
      if ( current ) {
        current.classList.remove( 'is-active' );
      }

      thumbnail.classList.add( 'is-active' );
      current = thumbnail;
    }
  } );

  productGallery.mount();
}


let productsGridImagesGallery = document.getElementsByClassName( 'js-products-gird-images-gallery' );

for ( let i = 0; i < productsGridImagesGallery.length; i++ ) {
  new Splide( productsGridImagesGallery[ i ], {
    pagination: false,
    type: 'loop',
  }).mount();
}


let bannersSlider1 = document.querySelector( '.block-banners-slider-4 .splide' );

if(bannersSlider1) {
  new Splide( bannersSlider1, {
    pagination: false,
    arrows: false,
    type: 'loop',
    perPage: 4,
    breakpoints: {
      768: { perPage: 3},
    },
  }).mount();
};

let bannersSlider2 = document.querySelector( '.block-banners-slider-5 .splide' );

if(bannersSlider2) {
  new Splide( bannersSlider2, {
    pagination: false,
    arrows: false,
    type: 'loop',
    perPage: 5,
    breakpoints: {
      768: { perPage: 3},
    },
  }).mount();
};

let bannersSlider3 = document.querySelector( '.block-banners-slider-8 .splide' );

if(bannersSlider3) {
  new Splide( bannersSlider3, {
    pagination: false,
    arrows: false,
    type: 'loop',
    perPage: 4,
    breakpoints: {
      768: { perPage: 3},
    },
  }).mount();
};


let bannersSlider4 = document.querySelector( '.block-banners-slider-7 .splide' );

if(bannersSlider4) {
  new Splide( bannersSlider4, {
    pagination: false,
    arrows: false,
    type: 'loop',
    perPage: 4,
    breakpoints: {
      768: { perPage: 3},
    },
  }).mount();
};





let jsNavMobileEl = document.querySelector('.js-nav-mobile');

if(jsNavMobileEl) {
  let navMobileSlider = new Splide( '.js-nav-mobile', {
    pagination: false,
    type: 'loop',
    perPage: 4,
    autoWidth: true,
    breakpoints: {
      768: { perPage: 6},
      640 : { perPage: 4},
    },
  });

  let navMobileSliderBar = navMobileSlider.root.querySelector( '.js-nav-mobile-progress' );
  if(navMobileSliderBar) {
    navMobileSlider.on( 'mounted move', function () {
      let end  = navMobileSlider.Components.Controller.getEnd() + 1;
      let rate = Math.min( ( navMobileSlider.index + 1 ) / end, 1 );
      navMobileSliderBar.style.width = String( 100 * rate ) + '%';
    });

  }

  navMobileSlider.mount();

}




let productsGridSlider = document.getElementsByClassName( 'js-products-grid-slider' );

for ( let i = 0; i < productsGridSlider.length; i++ ) {
  new Splide( productsGridSlider[ i ], {
    pagination: false,
    type: 'slide',
    perPage: 2,
    mediaQuery: 'min',
    breakpoints: {
      768: {
        perPage: 4,
      },
    }
  }).mount();
}

document.addEventListener('DOMContentLoaded', function() {

  return;

  setTimeout(function() {
    window.scrollTo(0, 1);
  }, 0);

  let header = document.querySelector('.js-sticky-header');
  let cartOverlay = document.querySelector('.js-cart-overlay');
  let ghostDiv = document.querySelector('.js-ghost');
  let offsetTop = 0;

  function handleScroll() {
    if (window.pageYOffset > offsetTop) {
      header.classList.add('sticky');
      cartOverlay.classList.add('sticky');
      ghostDiv.style.height = header.offsetHeight + 'px';
    } else {
      header.classList.remove('sticky');
      cartOverlay.classList.remove('sticky');
      ghostDiv.style.height = '0';
    }
  }

  window.addEventListener('scroll', handleScroll);

  function toggleMenuItems() {
    if (window.innerWidth < 768) {
      let menuItems = document.querySelectorAll('.menu-item-has-children a');

      for (let i = 0; i < menuItems.length; i++) {
        menuItems[i].addEventListener('click', function(e) {
          e.preventDefault();

          this.classList.toggle('active');
          let submenu = this.nextElementSibling;

          if (!submenu.style.maxHeight) {
            submenu.style.maxHeight = submenu.scrollHeight + 'px';
          } else {
            submenu.style.maxHeight = null;
          }
        });
      }
    }
  }

  toggleMenuItems();

  window.addEventListener('resize', toggleMenuItems);

  let firstCurrencyLinks = document.querySelectorAll('#alg_currency_selector a:first-child');
  for (let i = 0; i < firstCurrencyLinks.length; i++) {
    firstCurrencyLinks[i].addEventListener('click', function(e) {
      e.preventDefault();
    });
  }

  let menuButton = document.querySelector('.js-menu-button');
  let headerNav = document.querySelector('.header__nav');
  let headerMain = document.querySelector('.header__main');
  let body = document.querySelector('body');

  menuButton.addEventListener('click', function(e) {
    e.preventDefault();
    this.classList.toggle('active');
    headerMain.classList.toggle('active');
    headerNav.classList.toggle('active');
    body.classList.toggle('menu-show');
  });
});

(function($) {

  if($(window).width() > 1024) {
    $('.main-header').on('mouseleave', function(e) {
      e.preventDefault();
      $('.main-header').removeClass('active');
      $('.megamenu').removeClass('active');
      $('.menu-item-has-children').removeClass('active');
      $('.main-header__menu-btn').removeClass('active');
    });
  }


  $('.menu-item-has-children').on('click', function(e) {
    e.preventDefault();

    // Find the parent <li>
    let parentLi = $(this).closest('li');

    // Get the index of parent <li> within its siblings
    let parentIndex = parentLi.index() + 1;

    $('.megamenu__left-menu--hamburger').hide();
    $('.megamenu__center-menus').hide();
    $('.megamenu__center-menus[data-menu="'+ parentIndex +'"]').show();
    $('.megamenu__left-menu:not(.megamenu__left-menu--hamburger)').show();
    $('.megamenu__left-menu--hamburger').hide();

    if($(this).hasClass('active')) {
      $('.menu-item-has-children').removeClass('active');
      $('.main-header').removeClass('active');
      $('.megamenu').removeClass('active');
    } else {
      $('.menu-item-has-children').removeClass('active');
      $('.main-header').removeClass('active');
      $('.megamenu').removeClass('active');
      $('.megamenu').toggleClass('active');
      $(this).addClass('active');
      $('.main-header').addClass('active');
    }

  });

  $('.main-header__cart-contents').on('click', function(e) {
    e.preventDefault();
    $('.js-floating-cart').addClass('active');
    $('.js-cart-backdrop').addClass('active');
  });

  $('.js-cart-backdrop, .js-close-cart').on('click', function(e) {
    e.preventDefault();
    $('.js-floating-cart').removeClass('active');
    $('.js-cart-backdrop').removeClass('active');
  });

  $('.main-header__menu-btn').on('click', function(e) {
    e.preventDefault();
    $('.megamenu__center-menus').hide();
    $('.megamenu__left-menu:not(.megamenu__left-menu--hamburger)').hide();
    $('.megamenu__left-menu--hamburger').show();
    $('.menu-item-has-children').removeClass('active');
    $('.main-header').removeClass('active');
    $('.main-header').toggleClass('active');
    $('.megamenu').toggleClass('active');
    $(this).toggleClass('active');
    $('.megamenu__center-menus[data-menu="0"]').show();
  });

  $('.main-header__search').on('click', function(e) {
    e.preventDefault();
    $('.main-header__menu-btn').trigger('click');
  });

  function toggleGroupFields() {
    let groupTitle = $(this);
    let groupFields = groupTitle.next('.products-filter__group-fields-wrapper');

    groupTitle.toggleClass('open');
    groupFields.toggleClass('open');

    groupFields.slideToggle();
  }
  let groupTitles = $('.products-filter__group-title.js-group-title');
  groupTitles.on('click', toggleGroupFields);


  $('.js-filter-button').on('click', function(e) {
    e.preventDefault();
    $('.js-filter-button').addClass('active');
    $('.js-products-filter-overlay').addClass('show');
    $('.js-products-filter').addClass('show');
  });

  $('.js-products-filter-overlay, .js-filter-close').on('click', function(e) {
    e.preventDefault();
    $('.js-products-filter-overlay').removeClass('show');
    $('.js-products-filter').removeClass('show');
    $('.js-filter-button').removeClass('active');
  });

  $('.block-hero--collection .block-hero__header-link').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('.block-hero--collection .block-hero__single:first').offset().top - 100
  }, 500);
  });

  $('.js-cart').on('mouseenter', function(e) {
    $('.js-cart-overlay').addClass('active');
  }).on('mouseleave', function(e) {
    $('.js-cart-overlay').removeClass('active');
  });

  $('body').on('click', '#fake-place-order', function(e) {
    e.preventDefault();
    if($('#regulaminCheckbox').is(':checked')) {
      $('#place_order').trigger('click');
    } else {
      $('#regulaminCheckbox').parent().addClass('woocommerce-invalid');
    }

  });

  $('body').on('focus', '.validate-required input', function(e) {
    $(this).closest('p').find('label').hide();
  });

  $('.validate-required input').each(function() {
    if ($(this).val().trim() === "") {
      $(this).closest('p').find('label').show();
    } else {
      $(this).closest('p').find('label').hide();
    }
  });

  $('body').on('blur', '.validate-required input', function(e) {
    if ($(this).val().trim() === "") {
      $(this).closest('p').find('label').show();
    } else {
      $(this).closest('p').find('label').hide();
    }
  });

  // $(document).on('updated_wc_div', function(event, fragments, cart_hash) {
  //   let total = parseFloat($('.js-products-cart .woocommerce-Price-amount.amount bdi').text());
  //   let free_delivery = 400;
  //   let retur = free_delivery - total;

  //   if(total > free_delivery) {
  //     $('.js-cart-stripe-top').addClass('active');
  //     $('.js-cart-stripe-top').html('Przysługuje Ci <b>darmowa dostawa!</b>');
  //   } else {
  //     $('.js-cart-stripe-top').removeClass('active');
  //     $('.js-cart-stripe-top').html('Do darmowej dostawy <b>brakuje tylko</b> '+retur+' PLN');
  //   }

  // });

  $(document).on('added_to_cart', function(event, fragments, cart_hash) {

    if(fragments != undefined) {
      $('.js-products-cart').remove();
      $('.main-header__cart-bottom').before(fragments['div.widget_shopping_cart_content'])
      $('div.widget_shopping_cart_content').addClass('js-products-cart');
      $('.js-cart-overlay').addClass('open');
      $('.js-floating-cart').addClass('active').removeClass('hidden');
      $('.js-cart-backdrop').addClass('active');
      $('.js-add-to-cart-text').addClass('active');


        // Update the quantity and price display
      if(fragments['.main-header__cart-title-qtt']){
          $('.main-header__cart-title-qtt').html(fragments['.main-header__cart-title-qtt']);
      }
      if(fragments['.main-header__cart-bottom-bottom-total-price']){
          $('.main-header__cart-bottom-bottom-total-price').html(fragments['.main-header__cart-bottom-bottom-total-price']);
      }
      if(fragments['.quantity-number']){
          $('.quantity-number').each(function(index, element){
              var productId = $(element).data('product-id');
              if(fragments['.quantity-number-' + productId]){
                  $(element).html(fragments['.quantity-number-' + productId]);
              }
          });
      }
    }


    $.ajax({
      url: ajax_url, // Ensure this variable is correctly defined in your script
      type: 'POST',
      data: {
          action: 'get_cart_details' // The action to fetch cart details
      },
      success: function(response) {
          // Update the quantity and price display
          if(response.totalQuantity){
              $('.main-header__cart-title-qtt').html('(' + response.totalQuantity + ')');
              $('.main-header__cart-quantity').html(response.totalQuantity);
          }
          if(response.totalPrice){
              $('.main-header__cart-bottom-bottom-total-price').html(response.totalPrice);
          }
      }
    });

  });

  $('.js-close-cart').on('click', function(e) {
    e.preventDefault();
    $('.js-add-to-cart-text').removeClass('active');
    $('.js-cart-overlay').removeClass('open');
    $('.js-floating-cart').removeClass('active').addClass('hide');
    $('.js-cart-backdrop').removeClass('active');
      setTimeout(function() {
        $('.js-floating-cart').removeClass('hide');
    }, 500);
  });



  $('.js-filter-reset, .js-filter-selected-clear').on('click', function(e) {
    e.preventDefault();
    $('.js-countable-group').find('input[type="checkbox"]').prop('checked', false);
    $('.js-countable-group').find('input[type="number"]').val('');
    $('.js-filter-submit').trigger('click');
    $('.js-filter-single').remove();
    $('.js-filter-selected').hide();

    if($('.tax-product_cat').length) {
      window.location.href="https://kopi.com.pl/sklep/";
    }

  });
  $('body').on('click', '.js-filter-single-selected', function(e) {
    e.preventDefault();
    let target = $(this).data('target');
    if(target == 'price') {
      $('#price-min').val('');
      $('#price-max').val('');
    } else {
      $('#' + target).prop('checked', false);
    }

    $('.js-filter-submit').trigger('click');
    $(this).parent().remove();
    if($('.js-filter-single-selected').length == 0) {
      $('.js-filter-selected').hide();
    }
  });


  $(document).ready(function() {

    $('body').on('click', '.quantity-button', function() {
      var button = $(this);
      var productId = button.data('product-id'); // Ensure your button has a data attribute for product ID
      var productContainer = button.closest('.main-header__cart-product');
      var quantityField = button.closest('.main-header__cart-product-quantity').find('.quantity-number');
      var currentQuantity = parseInt(quantityField.text());
      var newQuantity = currentQuantity;


      // Determine action: plus or minus
      if (button.hasClass('plus')) {
          newQuantity = currentQuantity + 1;
      } else if (button.hasClass('minus')) {
          newQuantity = currentQuantity - 1;
      }

      // AJAX request to update or remove product based on the new quantity
      $.ajax({
          url: ajax_url, // Ensure this variable is correctly defined in your script
          type: 'POST',
          data: {
              action: 'adjust_product_quantity', // Update the action name as per your WordPress setup
              productId: productId,
              quantity: newQuantity
          },
          success: function(response) {
              response = JSON.parse(response);
              if (response.success) {
                  if (newQuantity <= 0) {
                      // Remove product from DOM
                      productContainer.remove();
                  } else {
                      // Update the quantity display
                      quantityField.text(newQuantity);
                  }

                  // Refresh the cart totals and trigger cart update
                  $('body').trigger('updated_cart_totals'); // Refresh the cart totals
                  $("[name='update_cart']").trigger("click");
              } else {
                  // Handle error (e.g., product not found)
                  console.error(response.message);
              }
          }
      });
  });

  let current_currency = $('#current_show_currency').val();

  if(current_currency == 'EUR') {
    if($('.gift-wrapper__checkbox:checked').length) {
      $('.woocommerce-shipping-totals.shipping').after('<tr class="woocommerce-shipping-totals shipping"><th class="shipping-title">Opakowanie prezentowe</th><td data-title="Opakowanie prezentowe" asd>'+ $('.gift-wrapper__checkbox:checked').length*1 +' EUR</td></tr>')
    }
  } else {
    if($('.gift-wrapper__checkbox:checked').length) {
      $('.woocommerce-shipping-totals.shipping').after('<tr class="woocommerce-shipping-totals shipping"><th class="shipping-title">Opakowanie prezentowe</th><td data-title="Opakowanie prezentowe" asd>'+ $('.gift-wrapper__checkbox:checked').length*5 +' PLN</td></tr>')
    }
  }




  $('body').on('updated_cart_totals', function() {
    // Your AJAX call

    $.ajax({
        url: ajax_url, // URL to your server-side script
        type: 'POST',
        data: {
            action: 'get_cart_details' // The action to fetch cart details
        },
        success: function(response) {
            // Assuming 'response' is an object with 'totalPrice' and 'totalQuantity'
            // Update the total price
            $('.main-header__cart-bottom-bottom-total-price .woocommerce-Price-amount bdi').html(response.totalPrice);
            $('.main-header__cart-quantity').text(response.totalQuantity);
            // Update the total quantity
            $('.main-header__cart-title .main-header__cart-title-qtt').text('(' + response.totalQuantity + ')');
        }
    });



    // giftWrappers.forEach(function(item) {
    //   $('#'+item).prop('checked', true);
    // });

    if($('.woocommerce-cart').length) {
      let giftWrapper = $('.wc-giftwrap');

      if(giftWrapper.length) {
        giftWrapper.each(function() {
          let buttonToggle = $(this).find('.wcgwp-remove-button');
          if(buttonToggle.is(':visible')) {
            $(this).closest('.woocommerce-cart-form__cart-item').find('.gift-wrapper__checkbox').prop('checked', true);
          }
        });
      }
    }
    let current_currency = $('#current_show_currency').val();
    if(current_currency == 'EUR') {
      if($('.gift-wrapper__checkbox:checked').length) {
        $('.woocommerce-shipping-totals.shipping').after('<tr class="woocommerce-shipping-totals shipping"><th class="shipping-title">Opakowanie prezentowe</th><td data-title="Opakowanie prezentowe" qww>'+ $('.gift-wrapper__checkbox:checked').length*1 +' EUR</td></tr>')
      }
    } else {
      if($('.gift-wrapper__checkbox:checked').length) {
        $('.woocommerce-shipping-totals.shipping').after('<tr class="woocommerce-shipping-totals shipping"><th class="shipping-title">Opakowanie prezentowe</th><td data-title="Opakowanie prezentowe" qww>'+ $('.gift-wrapper__checkbox:checked').length*5 +' PLN</td></tr>')
      }
    }


  });


    $('body').on('change', '.product-gift-wrap input', function() {
      var isChecked = $(this).is(':checked');
      $.ajax({
          url: ajax_url,
          type: 'POST',
          data: {
              action: 'adjust_product_price',
              checked: isChecked
          },
          success: function(response) {
              $('body').trigger('updated_cart_totals'); // Refresh the cart totals
              $("[name='update_cart']").trigger("click");
          }
      });
    });

    $('body').on('updated_cart_totals', function(){


    });

    // $(document).on('change', '.product-gift-wrap input', function() {
    //   if ($(this).is(':checked')) {
    //       // Checkbox is checked.
    //       $(document.body).trigger('update_checkout');
    //   } else {
    //       // Checkbox is not checked.
    //       $(document.body).trigger('update_checkout');
    //   }
    // });



    let timeout;

    // $('.woocommerce').on('click', '.quantity .plus, .quantity .minus', function() {
    //   console.log('test');
    //   if ( timeout !== undefined ) {
    //     clearTimeout( timeout );
    //   }
    //   timeout = setTimeout(function() {
    //     $("[name='update_cart']").removeAttr('disabled');
    //     $("[name='update_cart']").trigger("click");
    //   }, 1000 );
    // });
		// $('.woocommerce').on('change', 'input.qty', function(){

		// 	if ( timeout !== undefined ) {
		// 		clearTimeout( timeout );
		// 	}
		// 	timeout = setTimeout(function() {
    //     $("[name='update_cart']").removeAttr('disabled');
		// 		$("[name='update_cart']").trigger("click");

		// 	}, 1000 );
		// });

    $('.js-hero-modal-btn').on('click', function(e) {
      e.preventDefault();
      let modal = $(this).data('modal');
      $('.js-hero-modal[data-modal="' + modal + '"]').addClass('active');
    });

    $('.js-hero-modal .block-hero__modal-close').on(  'click', function(e) {
      e.preventDefault();
      $(this).closest('.js-hero-modal').removeClass('active');
      var iframe = $('.js-hero-modal iframe');
      iframe.attr('src', iframe.attr('src'));
    });

    if ($(window).innerWidth() < 768) {
      $('.block-footer__single-inner').on('click', function() {
        let $this = $(this);
        let $wrap = $this.find('.block-footer__single-wrap');

        $wrap.toggle();
        $this.toggleClass('rotate');
      });
    }

    $('.js-tab-intro').on('click', function(e) {
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    });

    $('.product-variants-select, .form-row select').select2({
      minimumResultsForSearch: -1
    });


  });

  $('.js-filter-form').on('submit', function(e) {
    e.preventDefault();
    let form = $(this);
    let data = form.serialize();
    filter_products(data);
  });

  $('body').on('click', '.js-pagination a.page-numbers', function(e) {
    e.preventDefault();
    let page_number = parseInt($(this).text());
    let data = $('.js-filter-form').serialize();
    filter_products(data, page_number);
    $('html, body').animate({
      scrollTop: $('.products-archive__header').offset().top - 100
    }, 500);

    // Update URL without reloading the page
    if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?page-number=' + page_number;
        window.history.pushState({path:newurl}, '', newurl);
    }
  });

  $(document).ready(function() {
    // Function to parse URL query parameters
    function getQueryParam(param) {
        var result = window.location.search.match(new RegExp("(\\?|&)" + param + "(\\[\\])?=([^&]*)"));
        return result ? result[3] : false;
    }

    // Check if 'page-number' parameter is in the URL
    var pageNumber = getQueryParam('page-number');
    if (pageNumber) {
        pageNumber = parseInt(pageNumber, 10); // Convert to integer
        let data = $('.js-filter-form').serialize();
        filter_products(data, pageNumber); // Call the filter_products function with the page number
    }
  });


  setTimeout(function() {
    $('.variation-radios input').each(function() {
      let value = $(this).val(); // Get the value of the radio button
      let option = $('option[value="' + value + '"]'); // Find the corresponding option in the select dropdown


          if (option.length > 0) {
            if (option.is(':disabled')) {
                $(this).attr('disabled', 'disabled');
                $(this).next().attr('title', 'Produkt niedostępny');
            } else {
            }
        } else {
        }
    });
  }, 500);


  $(document).on('change', '.variation-radios input', function() {
    $('.variation-radios input:checked').each(function(index, element) {
      var $el = $(element);
      var thisName = $el.attr('name');
      var thisVal  = $el.attr('value');
      $('select[name="'+thisName+'"]').val(thisVal);
      // $('select[name="'+thisName+'"] option').removeAttr('selected').removeClass('.attached').removeClass('enabled');
      // $('select[name="'+thisName+'"] option[value="'+ thisVal +'"]').attr('selected', 'selected');
      // $('select[name="'+thisName+'"] option[value="'+ thisVal +'"]').addClass('attached').addClass('enabled');
      $('select[name="'+thisName+'"]').trigger('change')
      if($('select[name="'+thisName+'"] option[value="'+ thisVal +'"]').is(':disabled')) {
          $('.js-stock-form').show();
      } else {
          $('.js-stock-form').hide();
      }
    });
    let varioation_price = $('.woocommerce-variation-price .price').html();
    $('.single-product-content__summary .price').html(varioation_price);
  });

  function filter_products(data, page_number = 1) {

    $.ajax({
      url: ajax_url,
      method: 'POST',
      data: {
          action: 'products_filter',
          data: data,
          page_number: page_number
      },
      beforeSend: function() {
        $('.js-loader-wrapper, .js-filter-submit').addClass('loading');
      },
      success: function(data) {



          if(data.total_products == 0) {
            $('.js-products').html('<div class="empty">Brak produktów dla wybranych filtrów</div>');
          } else {
            $('.js-products').html(data.products);
          }


          $('.js-archive-count').text(data.total_products);
          $('.js-pagination').html(data.pagination);

          if((data.selected_filters-3) > 1) {
            $('.js-filter-title-products-count').text('('+(data.selected_filters-4) +')').show();
          } else {
            $('.js-filter-title-products-count').text('').hide();
          }

          let productsGridImagesGallery = document.getElementsByClassName( 'js-products-gird-images-gallery' );

          for ( let i = 0; i < productsGridImagesGallery.length; i++ ) {
            new Splide( productsGridImagesGallery[ i ], {
              pagination: false,
              type: 'loop',
            }).mount();
          }

          $('.js-products').removeClass('loading');
          $('.js-filter-selected .js-filter-single-item').remove('');


          if(($('input[name="price-max"]').val() != '') || ($('input[name="price-min"]').val() != '')) {
            let min_price = $('input[name="price-min"]').val();
            let max_price = $('input[name="price-max"]').val();

            let price_text = '';
            if(min_price != '') {
              price_text += 'od '+min_price;
            }
            if((($('input[name="price-max"]').val() != '') && ($('input[name="price-min"]').val() != ''))) {
              price_text += ' ';
            }

            if(max_price != '') {
              price_text += 'do '+max_price;
            }

             $('.js-filter-selected').prepend('<li class="js-filter-single-item"><div class="products-archive__filter-single-selected js-filter-single-selected" data-target="price">'+ price_text +'</div></li>')
             $('.js-filter-selected').show();
          }


          $('.js-countable-group input[type="checkbox"]:checked').each(function() {
            let name = $(this).next().text();
            let input_id = $(this).attr('id');
            let data_name = $(this).data('name');

            if($('.js-filter-single-selected[data-target="'+ input_id +'"]').length == 0) {
              if(data_name != undefined) {
                $('.js-filter-selected').prepend('<li class="js-filter-single-item"><div class="products-archive__filter-single-selected js-filter-single-selected" data-target="'+ input_id +'">'+ data_name +'</div></li>')
              } else {
                $('.js-filter-selected').prepend('<li class="js-filter-single"><div class="products-archive__filter-single-selected js-filter-single-selected" data-target="'+ input_id +'">'+ name +'</div></li>')
              }
            }

            $('.js-filter-selected').show();
          });
          $('.js-loader-wrapper, .js-filter-submit').removeClass('loading');
          $('.js-filter-close').trigger('click');
          $('.product-variants-select').select2({
            minimumResultsForSearch: -1
          });
      }
    });
  }


  $(document).ready(function() {

    $('body').on('click', '.js-back-to-store', function(e) {
      e.preventDefault();

      // Get current URL parameters
      var currentParams = new URLSearchParams(window.location.search);

      // Get the base URL from the data attribute of the clicked element
      var baseUrl = $(this).data('url');

      // Check if the base URL already has parameters
      var separator = baseUrl.includes('?') ? '&' : '?';

      // Append current parameters to the base URL
      var newUrl = baseUrl + separator + currentParams.toString();

      // Redirect to the new URL
      window.location.href = newUrl;
    });

    $('body').on('click', 'input[name="collection[]"]', function(e) {
      let value = $(this).val();

      // Construct the new URL with the 'kolekcja' query parameter
      let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?kolekcja=' + encodeURIComponent(value);

      // Update the URL in the browser without reloading the page
      window.history.pushState({path:newUrl}, '', newUrl);
    });


    $('.gobottom').on('click', function(e) {
      e.preventDefault();

      $('html, body').animate({
        scrollTop: $('.block-hero + .block-products-grid').offset().top - 120
      }, 500);
    });

    $('.js-access-form').on('submit', function(e) {
      e.preventDefault();
      var formData = $(this).serialize();

      $.ajax({
        url: ajax_url,
        type: "POST",
        data: {
          action: 'check_password',
          data: formData,
        },
        success: function(response) {
          if (response === 'true') {
            // Password is correct, reload the page
            location.reload();
          } else {
            // Password is incorrect, handle the error
          }
        },
        error: function(xhr, status, error) {
          // Handle any errors that occur during the AJAX request
        }
      });
    });


    function updatePrice(id) {
        // Get the selected variation values
        var variationValues = {};

        // Loop through select elements
        $('.products-grid__variants[data-id="'+ id +'"] .product-variants-select').each(function() {
            var attribute_name = $(this).attr('data-name').replace('product-variants-', '');
            var selectedValue = $(this).val();
            variationValues[attribute_name] = selectedValue;
        });

        // Loop through radio button elements
        $('input[type="radio"][name^="product-variants-"]:checked').each(function() {
            var attribute_name = $(this).attr('name').replace('product-variants-', '');
            var selectedValue = $(this).val();
            variationValues[attribute_name] = selectedValue;
        });

        // Make an AJAX call to get the updated price
        $.ajax({
            type: 'POST',
            url: ajax_url,
            data: {
                'action': 'update_product_price',
                'product_id': id,
                'variation_values': variationValues
            },
            success: function(response) {
                if (response.success) {
                    // Update the displayed price
                    var regularPrice = response.data.regular_price;
                    var salePrice = response.data.sale_price;
                    var parent = $('div[data-id="' + id + '"]').parent().parent();
                    if (salePrice !== '') {
                        parent.find('.products-grid__price--regular').html(regularPrice);
                        parent.find('.products-grid__price--sale').html(salePrice);

                    } else {
                        parent.find('.products-grid__price').html(regularPrice);
                    }
                    parent.find('.ajax_add_to_cart').attr('data-product_id', response.data.variation_id);
                }
            },
            error: function(error) {
            }
        });
    }

    // Bind the change event to the variation elements
    $('.product-variants-select, input[type="radio"][name^="product-variants-"]').on('change', function() {
        let product_id = $(this).parent().parent().parent().find('.products-grid__variants').data('id');
        updatePrice(product_id);
      });
  });

  // $('.product-grid__variations').each(function(e) {
  //   let variations = $('.product-grid__variations-option');
  //   variations.each(function(e) {

  //   });
  // });

  $(document).on('click', '.product-grid__variations-selected', function() {
      $(this).toggleClass('active');
  });

  $(document).on('click', '.modal-qtt', function(e) {
    e.preventDefault();
    let productName = $(this).parent().parent().find('.woocommerce-loop-product__title').text();

    $('.stock-form-modal').addClass('active');
    $('.js-stock-form-modal__title').text(productName);
    $('.js-backdrop').addClass('active');
  });

  $('.js-close-modal').on('click', function(e) {
    e.preventDefault();
    $('.stock-form-modal').removeClass('active');
    $('.js-backdrop').removeClass('active');
  });

  $('.js-backdrop').on('click', function(e) {
    e.preventDefault();
    $('.stock-form-modal').removeClass('active');
    $('.js-backdrop').removeClass('active');
  });

  if($('.woocommerce-cart').length) {
    let giftWrapper = $('.wc-giftwrap');

    if(giftWrapper.length) {
      giftWrapper.each(function() {
        let buttonToggle = $(this).find('.wcgwp-remove-button');
        if(buttonToggle.is(':visible')) {
          $(this).closest('.woocommerce-cart-form__cart-item').find('.gift-wrapper__checkbox').prop('checked', true);
        }
      });
    }
  }


  $(document).on('click', '.gift-wrapper__checkbox', function(e) {
    giftWrappers = [];
    let isChecked = $(this).is(':checked');
    if(isChecked) {
       giftWrappers.push($(this).attr('id'));
       $(this).parent().parent().find('.wcgwp-submit').trigger('click');
    } else {
      giftWrappers = giftWrappers.filter(function(item) {
        return item !== $(this).attr('id');
      });

      $(this).parent().parent().find('.wcgwp-remove-button').trigger('click');
    }


  });

  $(document).on('click', '.product-grid__variations-option', function() {
    let variation_id = $(this).data('variation-id');
    let product_url = $(this).data('product-url');
    let price = $(this).find('.fake-price').html();
    let name = $(this).find('b').text();
    let image_url = $(this).data('variation-image');
    let that = $(this);
    let test_price = $(this).data('price')
    let currencyChecker = $('.alg_currency_radio:checked').val();




    let formattedPrice = new Intl.NumberFormat('de-DE', {
      style: 'decimal',
      minimumFractionDigits: 2
    }).format(test_price);

    if(currencyChecker == 'PLN') {


      formattedPrice = formattedPrice+ ' <span class="woocommerce-Price-currencySymbol">zł</span>';
    } else {
      formattedPrice = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 0
      }).format(test_price);


      formattedPrice = formattedPrice+ ' <span class="woocommerce-Price-currencySymbol">€</span>';
    }

    console.log(formattedPrice);

    $.ajax({
      url: ajax_url,
      type: 'POST',
      data: {
          action: 'get_labels_info',
          data: variation_id,
      },
      success: function(response) {
        that.closest('.products-grid__item').find('.products-grid__labels').html(response);
      }
    });

    if(image_url) {
      let image = $(this).closest('.products-grid__item').find('.products-grid__image-wrapper a');
      image.html('<img src="'+ image_url +'" class="products-grid__image">');
      $(this).closest('.products-grid__item').find('li.is-visible').html('<a href="'+ product_url +'"><img src="'+ image_url +'" class="products-grid__image"></a>');
    }

    // Update the selected variation name
    $(this).closest('.product-grid__variations-single').find('.product-grid__variations-selected span').text(name);

    $(this).closest('.products-grid__item').find('.price').html(price);

    $(this).parent().parent().find('.product-grid__variations-selected').removeClass('active');
    // Update the button with the selected variation ID
    let button = $(this).closest('.products-grid__item').find('.add_to_cart_button');
    button.attr('data-product_id', variation_id);
    button.attr('href', '?add-to-cart=' + variation_id);

    $(this).closest('.products-grid__item').find('.product-grid__info-bottom bdi').html(formattedPrice);

  });

  let i = 0;

  $(document).on('click', '.product-grid__colors-single span', function() {
    let product_name = $(this).data('product-name');
    let product_id = $(this).data('product-id');
    let product_url = $(this).data('product-url');
    let product_image = $(this).data('product-image');
    let test_price = $(this).next().html();
    let product_wrapper = $(this).closest('.product-grid__info');


    console.log(test_price);

    let that = $(this);
    //let pairPrice = mainElement[0];

    $.ajax({
      url: ajax_url,
      type: 'POST',
      data: {
          action: 'get_single_tile_info',
          data: product_id,
      },
      success: function(response) {
        response = JSON.parse(response);
        that.closest('.products-grid__item').find('.product-grid__variations-single').html(response.variations_html);
        that.closest('.products-grid__item').find('.product-grid__variations + a').remove();
        that.closest('.products-grid__item').find('.product-grid__info-top').append(response.add_to_cart);

      }
    });

    $.ajax({
      url: ajax_url,
      type: 'POST',
      data: {
          action: 'get_labels_info',
          data: product_id,
      },
      success: function(response) {

        if(i == 0) {
          //that.trigger('click');
          i++;
        }
      }
    });

    $(this).closest('.product-grid__info-price').html(test_price);
    $(this).closest('.products-grid__item').find('.product-grid__variations-option.para').trigger('click');
    $(this).closest('.products-grid__item').find('.active').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.products-grid__item').find('.woocommerce-loop-product__title').text(product_name);
    if(product_image) {
      $(this).closest('.products-grid__item').find('li.is-visible').html('<a href="'+ product_url +'"><img src="'+ product_image +'" class="products-grid__image"></a>');
    }


    let product_price_wrapper = product_wrapper.find('.product-grid__info-price');
    product_price_wrapper.html(test_price);


    let paraPrice = $(this).closest('.products-grid__item').find('.product-grid__variations-option.para .fake-price.para').html();

    $(this).closest('.product-grid__info-price').html(paraPrice);

    //$(this).closest('.products-grid__item').find('.product-grid__info-price').html(price);

    // price.html(pairPrice);
    // $(this).closest('.products-grid__item').find('.product-grid__variations-option.para').trigger('click');
  });

  // Add click event handler for all plus buttons
  $("button[class^='plus']").on("click", function() {
    var input = $($(this).data("quantity-target"));
    var currentValue = parseInt(input.val());
    input.val(currentValue );
  });

  // Add click event handler for all minus buttons
  $("button[class^='minus']").on("click", function() {
    var input = $($(this).data("quantity-target"));
    var currentValue = parseInt(input.val());
    if (currentValue > 0) {
      input.val(currentValue);
    }
  });

  $(document).ready(function() {
    $('.category-filter a').on('click', function(event) { // Adjust the selector as needed
        event.preventDefault();

        var filterData = gatherFilterData();
        var queryString = $.param(filterData);
        var targetUrl = $(this).attr('href'); // Get the URL from the clicked link

        window.location.href = targetUrl + '?' + queryString;
    });

    function gatherFilterData() {
          var data = {};
          $('.products-filter__form').find('input[type="radio"]:checked, input[type="checkbox"]:checked, input[type="number"]').each(function() {
              var inputName = $(this).attr('name');
              if (inputName) {
                  let _inputName = inputName.replace('[]', '');
                  let fixCollection = _inputName.replace('collection', 'kolekcja');
                  data[fixCollection] = $(this).val();
              }
          });

          return data;
    }
  });

  $(document).ready(function() {

      if($('#transfer_filters').length) {
        $('.js-filter-submit').trigger('click');
      }


      $(".accordion-collapse").hide();
      $('body').on('click', '.accordion-header', function() {
        var collapse = $(this).next(".accordion-collapse");

        if (collapse.is(":hidden")) {
          collapse.slideDown("fast");
          $(this).addClass("active");
        } else {
          collapse.slideUp("fast");
          $(this).removeClass("active");
        }
      });

      $('.megamenu-mobile ul > li > a[href="#"] ').on('click', function(e) {
        e.preventDefault();
        $(this).next().addClass('active');
      });

      $('.back').on('click', function(e) {
        e.preventDefault();
        $('.megamenu-mobile .active').removeClass('active');
      });

  });

})( jQuery );












(function($) {
  $(document).ready(function() {
      // Ukrywamy przycisk "Przejdź do płatności" po załadowaniu strony
      $('#place_order').hide();

      // Obsługujemy wybór metody dostawy
      $('#shipping_method_form input[type="radio"]').on('change', function() {
          // Wyświetlamy ukryty przycisk "Przejdź do płatności"
          $('#place_order').show();

          // Aktualizujemy stronę automatycznie
          $('#shipping_method_form').submit();
      });
      $('body').on('click', '.wvg-gallery-thumbnail-image123', function(e) {
        e.preventDefault();
        let nth = $(this).index();
        $('html, body').animate({
          scrollTop: $('[data-slick-index="'+ nth +'"]').offset().top - 10
      }, 500);
      });
    });

    $(window).on('scroll', function() {
      let scrollTop = $(window).scrollTop();
      let viewportHeight = $(window).height() - 100;
      if($('.home').length) {
        if(scrollTop > $('.main-header__top-bar').height()) {
          $('.main-header__main').addClass('half-sticky');
        } else {
          $('.main-header__main').removeClass('half-sticky');
        }
        if (scrollTop > viewportHeight) { // Compare scrollTop with viewportHeight
          $('.main-header__main').addClass('sticky');
          $('.main-header').addClass('sticky');
        } else {
          $('.main-header__main').removeClass('sticky');
          $('.main-header').removeClass('sticky');
        }
      } else {
        if(scrollTop > 30) {
          $('.main-header__main').addClass('half-sticky');
        } else {
          $('.main-header__main').removeClass('half-sticky');
        }
        if (scrollTop > 30) { // Compare scrollTop with viewportHeight
          $('.main-header__main').addClass('sticky');
          $('.main-header').addClass('sticky');
        } else {
          $('.main-header__main').removeClass('sticky');
          $('.main-header').removeClass('sticky');
        }
      }

    });

    $('#gobottom').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: $('.block-hero + .block-products-grid').offset().top - 120
      });
    });

})(jQuery);



   // quantity
   function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

    if (!isNaN(currentVal)) {
      parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
    } else {
      parent.find('input[name=' + fieldName + ']').val(0);
    }
  }



  function calculateDeliveryTime() {
    const now = new Date();
    const currentTime = now.getTime();

    const isWeekday = now.getDay() >= 1 && now.getDay() <= 5;
    const isBefore3PM = now.getHours() < 15;

    if (isWeekday && isBefore3PM) {
      const deliveryTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 0, 0);
      const difference = deliveryTime.getTime() - currentTime;

      if (difference > 0) {
        const hours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        document.querySelector(".product-delivery-box").innerHTML = `Dostawa jutro. Pozostało: ${hours} godzin, ${minutes} minut.`;
      } else {
        let daysToAdd = 1;
        if (now.getDay() === 5) {
          daysToAdd = 3; // Jeśli jest piątek, dostawa będzie w poniedziałek (3 dni)
        } else if (now.getDay() === 6) {
          daysToAdd = 2; // Jeśli jest sobota, dostawa będzie we wtorek (2 dni)
        }

        const deliveryTime = new Date(now);
        deliveryTime.setDate(deliveryTime.getDate() + daysToAdd);
        deliveryTime.setHours(15, 0, 0, 0);

        const difference = deliveryTime.getTime() - currentTime;

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        let deliveryDay = "jutro";
        if (days === 2) {
          deliveryDay = "pojutrze";
        } else if (days > 2) {
          deliveryDay = `${days} dni`;
        }

        document.querySelector(".product-delivery-box").innerHTML = `Dostawa będzie ${deliveryDay}. Pozostało: ${hours} godzin, ${minutes} minut.`;
      }
    } else {
      let daysToAdd = isWeekday ? 1 : 3;
      if (isWeekday && !isBefore3PM) {
        daysToAdd = 2; // jeśli jest po 15:00 w dniu roboczym, dostawa będzie za 2 dni (poniedziałek -> wtorek)
      }

      const deliveryTime = new Date(now);
      deliveryTime.setDate(deliveryTime.getDate() + daysToAdd);
      deliveryTime.setHours(15, 0, 0, 0);

      const difference = deliveryTime.getTime() - currentTime;

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      let deliveryDay = "jutro";
      if (days === 2) {
        deliveryDay = "pojutrze";
      } else if (days > 2) {
        deliveryDay = `${days} dni`;
      }

      document.querySelector(".product-delivery-box").innerHTML = `Dostawa będzie ${deliveryDay}. Pozostało: ${hours} godzin, ${minutes} minut.`;
    }
  }

  // Wywołujemy funkcję na starcie i co sekundę odświeżamy czas
  //calculateDeliveryTime();
  //setInterval(calculateDeliveryTime, 1000);



document.addEventListener("DOMContentLoaded", function() {
  var checkboxes = document.querySelectorAll('.custom-checkbox input');

  checkboxes.forEach(function(checkbox) {
    checkbox.addEventListener("change", function() {
      var parent = this.closest('.custom-checkbox');
      var productId = this.id.split("-")[0];
      var input = document.getElementById(productId + "-checkbox");

      if (this.checked) {
        parent.classList.add('checked');
        input.style.backgroundColor = "#000";
        input.style.color = "#fff";

        // Dodaj kod JavaScript do wykonania po zaznaczeniu checkboxa
        // Przykład: Zmiana stanu elementu na podstawie identyfikatora
        var messageContainer = document.getElementById(productId + "-message-container");
        messageContainer.style.display = "block";
      } else {
        parent.classList.remove('checked');
        input.style.backgroundColor = "";
        input.style.color = "";

        // Dodaj kod JavaScript do wykonania po odznaczeniu checkboxa
        // Przykład: Zmiana stanu elementu na podstawie identyfikatora
        var messageContainer = document.getElementById(productId + "-message-container");
        messageContainer.style.display = "none";
      }
    });
  });
});


function dodajDivZTekstemDoWszystkich() {
  const sumenuText = document.querySelector(".js-submenu-text").value;
  const htmlKodu = '<div class="subWrap">'+ sumenuText +'</div>'; // Kod HTML, który ma znaleźć się w dodanym <div>
  const ulElementy = document.querySelectorAll(".sub-menu");

  if (ulElementy.length > 0) {
    ulElementy.forEach((ulElement) => {
      ulElement.insertAdjacentHTML("beforeend", htmlKodu);
    });
  } else {
    console.error("Nie znaleziono elementów <ul> o klasie 'sub-menu'");
  }
}

dodajDivZTekstemDoWszystkich();


jQuery(document).ready(function($) {
  // Function to update quantity
  function updateQuantity(button, isAdding) {
      var quantityInput = $(button.data('quantity-target'));
      var currentQuantity = parseInt(quantityInput.val());
      var newQuantity = isAdding ? currentQuantity + 1 : currentQuantity - 1;

      // Ensure the quantity is within the allowed range
      newQuantity = Math.max(newQuantity, parseInt(quantityInput.attr('min')));
      newQuantity = Math.min(newQuantity, parseInt(quantityInput.attr('max')));

      // Update the input field
      quantityInput.val(newQuantity);
      quantityInput.change(); // Trigger change event to update WooCommerce cart
  }

  // Handle click on the minus button
  $('body').on('click', '.quantity .minus', function() {
      updateQuantity($(this), false);
      $('button[name="update_cart"]').trigger('click');
  });

  // Handle click on the plus button
  $('body').on('click', '.quantity .plus', function() {
      updateQuantity($(this), true);
      $('button[name="update_cart"]').trigger('click');
  });

  if($('#shipping_method li:first-child input').length) {
    setTimeout(function() {
      $('#shipping_method li:first-child input').trigger('click');
    }, 1000);

  }


});